const MESSAGE_PROPS = `
  messages {
      error {
        label
        value
        code
      }
      warning {
        label
        value
        code
      }
      info {
        label
        value
        code
      }
    }`;

const LINE_ITEM_PROPS = `
productId
variantId
quantity
name
sku
label
url
price
totalPrice
formattedTotalPrice
isPreorder
publishedProduct {
  name
  id
  url
  variants {
    variantId
    minQuantity
    maxQuantity
  }
  image {
    url
  }
}
${MESSAGE_PROPS}
`;

const ADDRESS_PROPS = `
  id
  title
  firstname
  lastname
  company
  country
  county
  address1
  address2
  city
  postcode
  tel
  company
`;

const CART_DATA_DEFAULT_RESULT_PROPS = `
    id
    created
    updated
    formattedCreated
    formattedUpdated
    user {
      id
      email
    }
    shippingAddress {
      ${ADDRESS_PROPS}
    }
    billingAddress {
      ${ADDRESS_PROPS}
    }
    currency
    formattedPreorderTotal
    formattedAvailableTotal
    formattedDiscountsTotal
    formattedShippingTotal
    formattedTaxTotal
    formattedTotal
    formattedTotalDue
    formattedTotalDueLater
    total
    formattedTotalWithoutShipping
    completed
    lineItems {
        ${LINE_ITEM_PROPS}
    },
    discounts {
      id
      name
      price
      totalPrice
      formattedTotalPrice
      quantity
    },
    hasErrors
    ${MESSAGE_PROPS}
`;

export { LINE_ITEM_PROPS, CART_DATA_DEFAULT_RESULT_PROPS };
